export type TrafficModel = 'sprinter' | 'hiace' | 'taxi' | 'saloon' | 'suv' | 'truck' | 'pragya' | 'aboboyaa' | 'barrier';

export interface TrafficKind {
  id: TrafficModel;
  label: string;
  length: number;
  width: number;
  height: number;
  /** Cruise speed range in m/s. */
  speed: readonly [min: number, max: number];
  /** Relative spawn weight. */
  weight: number;
  /** Low obstacles can be hopped over. */
  hoppable: boolean;
}

export const TRAFFIC_KINDS: readonly TrafficKind[] = [
  { id: 'taxi', label: 'a taxi', length: 4.5, width: 1.78, height: 1.46, speed: [6, 11], weight: 4, hoppable: false },
  { id: 'saloon', label: 'a car', length: 4.5, width: 1.78, height: 1.46, speed: [7, 12], weight: 3, hoppable: false },
  { id: 'suv', label: 'a big SUV', length: 4.8, width: 1.9, height: 1.85, speed: [7, 12], weight: 2, hoppable: false },
  { id: 'sprinter', label: 'another Sprinter trotro', length: 5.9, width: 2.0, height: 2.75, speed: [5, 9], weight: 2, hoppable: false },
  { id: 'hiace', label: 'a Toyota trotro', length: 5.38, width: 1.9, height: 2.28, speed: [5, 9], weight: 2, hoppable: false },
  { id: 'pragya', label: 'a pragya', length: 2.7, width: 1.3, height: 1.8, speed: [4, 7], weight: 1.5, hoppable: false },
  { id: 'aboboyaa', label: 'an aboboyaa', length: 3.0, width: 1.5, height: 1.9, speed: [3, 6], weight: 1.5, hoppable: false },
  { id: 'truck', label: 'a Kia truck', length: 7.2, width: 2.3, height: 3.1, speed: [4, 7], weight: 1, hoppable: false },
  { id: 'barrier', label: 'a road barrier (hop it next time!)', length: 0.6, width: 3.0, height: 0.95, speed: [0, 0], weight: 0.7, hoppable: true },
];

/** Distinct looks per kind; meshes are cached per (kind, variant). */
export const VARIANTS_PER_KIND = 6;
